import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { SlidersHorizontal } from "lucide-react";
import api from "@/lib/api";
import ProductCard from "@/components/ProductCard";

const SORTS = [
  { v: "popular", l: "Más vendidos" },
  { v: "price_asc", l: "Precio: menor" },
  { v: "price_desc", l: "Precio: mayor" },
  { v: "rating", l: "Mejor valorados" },
];

export default function Catalog() {
  const [params, setParams] = useSearchParams();
  const category = params.get("category") || "Todos";
  const search = params.get("search") || "";
  const linea = params.get("linea") || "";
  const [sort, setSort] = useState("popular");
  const [products, setProducts] = useState([]);
  const [cats, setCats] = useState(["Todos"]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const p = linea ? { product_line: linea } : {};
    api.get("/categories", { params: p }).then((r) => setCats(["Todos", ...r.data]));
  }, [linea]);

  useEffect(() => {
    setLoading(true);
    const p = { sort };
    if (category && category !== "Todos") p.category = category;
    if (search) p.search = search;
    if (linea) p.product_line = linea;
    api.get("/products", { params: p }).then((r) => { setProducts(r.data); setLoading(false); });
  }, [category, search, sort, linea]);

  const LINEA_LABEL = {
    distribuidor_oficial: "Distribución oficial",
    perfumes_local: "Perfumería",
    cj: "Tendencias",
  };

  const setCategory = (c) => {
    const np = new URLSearchParams(params);
    if (c === "Todos") np.delete("category"); else np.set("category", c);
    setParams(np);
  };

  return (
    <div className="max-w-7xl mx-auto px-3 md:px-6 py-6">
      <div className="flex items-end justify-between flex-wrap gap-3 mb-5">
        <div>
          <h1 className="font-display font-black text-3xl md:text-4xl uppercase tracking-tight">
            {search ? `"${search}"` : (category === "Todos" && linea ? (LINEA_LABEL[linea] || category) : category)}
          </h1>
          <p className="text-drelo-muted text-sm mt-1">
            {products.length} productos
            {linea === "distribuidor_oficial"
              ? " · marcas que distribuimos en RD"
              : linea === "perfumes_local"
              ? " · stock local"
              : " · precios de locura 🔥"}
          </p>
        </div>
        <div className="flex items-center gap-2 bg-white border rounded-full px-3 py-2">
          <SlidersHorizontal className="w-4 h-4 text-drelo-muted" />
          <select value={sort} onChange={(e) => setSort(e.target.value)} className="bg-transparent text-sm font-semibold outline-none" data-testid="sort-select">
            {SORTS.map((s) => <option key={s.v} value={s.v}>{s.l}</option>)}
          </select>
        </div>
      </div>

      <div className="flex gap-2 overflow-x-auto pb-3 mb-5 -mx-1 px-1">
        {cats.map((c) => (
          <button key={c} onClick={() => setCategory(c)}
            className={`whitespace-nowrap px-4 py-2 rounded-full text-sm font-bold transition-all ${
              category === c ? "bg-drelo-primary text-white" : "bg-white border text-drelo-ink hover:border-drelo-primary"
            }`} data-testid={`filter-${c}`}>
            {c}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
          {Array(8).fill(0).map((_, i) => <div key={i} className="bg-white rounded-xl border h-80 animate-pulse" />)}
        </div>
      ) : products.length === 0 ? (
        <div className="text-center py-20 text-drelo-muted">No encontramos productos. Prueba otra categoría.</div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
          {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      )}
    </div>
  );
}
